import { render, staticRenderFns } from "./SingleCommunicationFields.vue?vue&type=template&id=1ef8a9b2&scoped=true"
import script from "./SingleCommunicationFields.vue?vue&type=script&lang=ts"
export * from "./SingleCommunicationFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef8a9b2",
  null
  
)

export default component.exports